import React, {FC} from 'react';
import {Grid, Container, useBreakpointUp} from '@bonprix/design-system';

import Separator from './Separator';
import LegalSection from './LegalSection';
import SupportSection from './SupportSection';

export interface StaticLinks {
    SERVICE_TERMS_AND_CONDITIONS: string;
    SERVICE_IMPRINT: string;
    SERVICE_PRIVACY: string;
    SERVICE_CONTACT: string;
    SERVICE_WITHDRAW_CONTRACT: string;
    SERVICE_ACCESSIBILITY: string;
    SERVICE_STATUTORY_WARRANTY: string;
}

interface CheckoutFooterProps {
    texts: {[key: string]: string};
    staticLinks: StaticLinks;
}

const CheckoutFooter: FC<CheckoutFooterProps> = ({texts, staticLinks}) => {
    const isLOrUp = useBreakpointUp('l');
    return (
        <footer>
            <Separator />
            <Container>
                <div className="pt-8 pb-10">
                    <Grid>
                        <Grid.Item s={0} l={1} />
                        <Grid.Item s={12} l={4} className="flex justify-center">
                            <SupportSection texts={texts} staticLinks={staticLinks} />
                        </Grid.Item>
                        <Grid.Item s={12} l={2} className="flex justify-center">
                            <Separator vertical={isLOrUp} />
                        </Grid.Item>
                        <Grid.Item s={12} l={4}>
                            <LegalSection texts={texts} staticLinks={staticLinks} />
                        </Grid.Item>
                        <Grid.Item s={0} l={1} />
                    </Grid>
                </div>
            </Container>
        </footer>
    );
};
export default CheckoutFooter;
